import { SSSAPInterface, sSSAPInterfaceHttpBindingInterceptor } from '@amzn/coral_com-amazon-sssapinterface';
import { CoralFetchHandler, CoralInterceptor, InterceptingHandler } from '@amzn/ihm-js-coral-client';

import { CSRFInterceptor } from 'src/clients/csrf-interceptor';
import { HeaderInterceptor } from 'src/clients/header-interceptor';

export const SSS_API_PATH = '/sss-api';

/**
 * Instantiate a client leveraging the generated Coral Client Http Interceptor bound to the
 * SSSAPI Model.
 */
export const createSssApiClient = (): SSSAPInterface => {
  const coralClientConfig = {
    httpEndpoint: {
      url: `${SSS_API_PATH}`,
    },
  };

  const interceptors: CoralInterceptor[] = [sSSAPInterfaceHttpBindingInterceptor, CSRFInterceptor, HeaderInterceptor];

  return new SSSAPInterface(coralClientConfig, new InterceptingHandler(new CoralFetchHandler(), interceptors));
};

export const sssApiClientSingleton = createSssApiClient();
